import React, { Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { formatDate } from '@utils/dates/date.utils';
import { MM_SLASH_DD_SLASH_YYYY } from '@utils/dates/dateFormats.utils';


const SecureInboxTableRow = props => {

    const {
        row: email,
        row: {
            emailSubject,
            date,
            pdfFileKey,
            read
        },
        setEmailShown
    } = props;

    const setEmailDate = date => formatDate(date, MM_SLASH_DD_SLASH_YYYY);

    const handleRowClick = () => {
        setEmailShown(email);
    };

    const keyPress = e => {
        const isEnter = e.key === 'Enter' || e.keyCode === 13;
        if (isEnter) {
            handleRowClick(e);
        }
    };

    const TABLE_ROW_DATA_DEFAULT = {
        DATE: setEmailDate(date),
        EMAIL_SUBJECT: emailSubject,
        PDF: pdfFileKey ? <FontAwesomeIcon icon='paperclip'/> : ''
    };

    const rowDataObj = TABLE_ROW_DATA_DEFAULT;
    return (
        <Fragment>
            <tr
                className={ 'pointer' + `${ read ? '' : ' text-bold' }` }
                tabIndex="0"
                onClick={handleRowClick}
                onKeyPress={keyPress}
            >
                {Object.keys(rowDataObj).map((tableDataKey) => (
                    <td key={tableDataKey}> {rowDataObj[tableDataKey] }</td>
                ))}
            </tr>
        </Fragment>
    );
};


export default SecureInboxTableRow;